export default "__VITE_ASSET__D4Vyo0qS__"